/**
 * Codes des motifs d'avenant attendus par devis-ws (DemandeTarif.Police.MotifAvenant).
 * Référentiel unique : les apps et le core doivent s'y référer plutôt qu'à des chaînes en dur.
 */
export const MOTIF_AVENANT = {
    CHANGEMENT_VEHICULE: '1',
    CHANGEMENT_GARANTIES: '2',
    CHANGEMENT_ADRESSE: '3',
    CHANGEMENT_CONDUCTEUR: '5',
    REMISE_EN_VIGUEUR: '6',
    REGULARISATION_PRIME: '7',
    MISE_A_JOUR_DECLARATION: '8',
    CHANGEMENT_USAGE: '9',
    MODIFICATION_CONTRAT: '10',
    CORRECTIF_AVENANT: '11',
    CHANGEMENT_VELO: '24',
    FIDELISATION: '29',
} as const;

export type MotifAvenant = (typeof MOTIF_AVENANT)[keyof typeof MOTIF_AVENANT];

export const MOTIF_AVENANT_LABELS: Record<MotifAvenant, string> = {
    [MOTIF_AVENANT.CHANGEMENT_VEHICULE]: 'Changement de véhicule',
    [MOTIF_AVENANT.CHANGEMENT_GARANTIES]: 'Changement de garanties',
    [MOTIF_AVENANT.CHANGEMENT_ADRESSE]: "Changement d'adresse",
    [MOTIF_AVENANT.CHANGEMENT_CONDUCTEUR]: 'Changement de conducteur',
    [MOTIF_AVENANT.REMISE_EN_VIGUEUR]: 'Remise en vigueur',
    [MOTIF_AVENANT.REGULARISATION_PRIME]: 'Régularisation de prime',
    [MOTIF_AVENANT.MISE_A_JOUR_DECLARATION]: 'Mise à jour de déclaration',
    [MOTIF_AVENANT.CHANGEMENT_USAGE]: "Changement d'usage",
    [MOTIF_AVENANT.MODIFICATION_CONTRAT]: 'Modification de contrat',
    [MOTIF_AVENANT.CORRECTIF_AVENANT]: "Correctif d'avenant",
    [MOTIF_AVENANT.CHANGEMENT_VELO]: 'Changement de vélo',
    [MOTIF_AVENANT.FIDELISATION]: 'Avenant de fidélisation',
};
